import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthenticationProvider } from 'nikao-authentication';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import SettingsPage from "./pages/SettingsPage";
import UserManagementPage from "./pages/UserManagementPage";
import ChangeRequestDetailPage from "./pages/ChangeRequestDetailPage";
import WorkflowBoardPage from "./pages/WorkflowBoardPage";
import PrivateRoute from "./components/Auth/PrivateRoute";
import FeedbackButton from "./components/Feedback/FeedbackButton";

const msalClientId = process.env.REACT_APP_MSAL_CLIENT_ID;
const msalTenantId = process.env.REACT_APP_MSAL_TENANT_ID;

const missing = [];
if (!msalClientId) missing.push('REACT_APP_MSAL_CLIENT_ID');
if (!msalTenantId) missing.push('REACT_APP_MSAL_TENANT_ID');
if (missing.length > 0) {
  throw new Error(`Missing required MSAL configuration: ${missing.join(', ')}`);
}
const msalAuthority = `https://login.microsoftonline.com/${msalTenantId}`;

const theme = createTheme({
  palette: {
    primary: {
      main: "#160E2B",
    },
    secondary: {
      main: "#C6E044",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthenticationProvider
      applicationId={msalClientId}
      authority={msalAuthority}
      redirectUri={typeof window !== 'undefined' ? window.location.origin : undefined}
    >
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DashboardPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/change-request/:id"
                element={
                  <PrivateRoute>
                    <ChangeRequestDetailPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <SettingsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <PrivateRoute>
                    <UserManagementPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/workflow"
                element={
                  <PrivateRoute>
                    <WorkflowBoardPage />
                  </PrivateRoute>
                }
              />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <FeedbackButton />
          </Router>
        </AuthProvider>
      </AuthenticationProvider>
    </ThemeProvider>
  );
}

export default App;
